const messages = {
    scanWithBankApp: "अपने बैंकिंग ऐप से स्कैन करें",
    scanWithCreditCardApp: "अपने क्रेडिट कार्ड ऐप से स्कैन करें",
    scanOrOpenApp: "भुगतान पूरा करने के लिए स्कैन करें या ऐप खोलें",
    scanForPayment: "भुगतान के लिए स्कैन करें",
    scanWithBankApp: 'भुगतान के लिए अपने बैंकिंग ऐप से स्कैन करें',
    changePaymentWarning: "भुगतान विधि बदलने पर, पिछला QR Code अमान्य हो जाएगा। कृपया केवल नई विधि का उपयोग करें।",
    swapShop: "क्या आप नई दुकान पर<br>स्विच करना चाहते हैं?",
    swapShopDespt: "पिछली दुकान से चुनी गई वस्तुएँ सहेज ली जाएंगी और बाद में ऑर्डर की जा सकती हैं",
    sorryForInconvenient: 'असुविधा के लिए हमें खेद है',
    openAt: 'खुलने का समय',
    shopIsClosedToday: 'आज दुकान बंद है',
    checkOrderedItem: 'ऑर्डर किए गए खाद्य पदार्थ जाँचें',
    tryAgainIn: 'पुनः प्रयास करें',
    lockUserPIN: "आपने 5 से अधिक बार गलत PIN दर्ज किया है",
    lockUserPINDespt: "5 मिनट बाद पुनः प्रयास करें",
    inValidPIN: 'गलत PIN',
    enterPasswordToAccessMenu: "मेनू तक पहुँचने के लिए PIN दर्ज करें",
    customersCanGetPasswordFromStaff: "ग्राहक स्टाफ से PIN प्राप्त कर सकते हैं",
    tableNotAvailable: "टेबल उपलब्ध नहीं है",
    contactStaffToOpenTable: "टेबल खोलने के लिए स्टाफ से संपर्क करें",
    outOfRestaurantRange: "रेस्तरां की सीमा के बाहर",
    phoneIsMoreThan100MetersAwayFromRestaurant: "आपका फ़ोन रेस्तरां से 100 मीटर से अधिक दूर है",
    restaurantIsCurrentlyClosed: "रेस्तरां वर्तमान में बंद है",
    restaurantOpenHours: "किचन खुलने का समय",
    packingSize: 'पैकेज का आकार',
    shippingDelivery: 'शिपिंग',
    waitForPaymentDelivery: 'भुगतान की प्रतीक्षा',
    readyForPcikup: 'पिकअप के लिए तैयार',
    noNotifyNow: "अभी कोई सूचना नहीं",
    noNotifyNowDespt: "जब आप सेवा का उपयोग शुरू करेंगे, तो आपकी सूचनाएँ यहाँ दिखाई देंगी",
    newAddressDespt: "आसान डिलीवरी के लिए, कृपया सही गंतव्य पिन करें और अपने स्थान तक पहुँच की अनुमति दें",
    deleteAddressSuccess: 'पता सफलतापूर्वक हटाया गया',
    createProfileSuccess: "प्रोफ़ाइल सफलतापूर्वक बनाई गई",
    ex: 'उदा.',
    receiverName: 'प्राप्तकर्ता का नाम',
    editAddress: 'पता संपादित करें',
    nameInputInvalid: 'गलत नाम',
    openInGoogleMap: 'Google Map में खोलें',
    pleaseSelectPaymentMethod: 'कृपया भुगतान विधि चुनें',
    noDeliveryAddress: 'कोई डिलीवरी पता नहीं मिला',
    noDeliveryAddressDespt: 'कृपया डिलीवरी पता जोड़ें',
    deliveryType: 'डिलीवरी',
    pickupType: 'पिक-अप',
    shopIsClose: 'दुकान बंद है',
    openingHoursDespt: 'खुलने का समय',
    contactShop: 'दुकान से संपर्क करें',
    pickupAtShop: 'पिक-अप',
    thanksForOrderingDespt: 'आपकी कृपा के लिए धन्यवाद।<br>हम आपसे फिर मिलने की उम्मीद करते हैं!',
    deliveredSuccess: 'डिलीवर हो गया',
    expireIn: 'समाप्ति',
    waitForPayment: 'भुगतान की प्रतीक्षा',
    waitForPaymentDespt: "कृपया सिस्टम से भुगतान की पुष्टि की प्रतीक्षा करें।<br>यदि आपने अभी तक भुगतान नहीं किया है, तो ऑर्डर रद्द होने से बचने के लिए निर्धारित समय के भीतर भुगतान पूरा करें।",
    newOrderIn: 'नया',
    inputRequestDetails: 'अनुरोध विवरण निर्दिष्ट करें',
    notification: 'सूचना',
    noticeIfOrderReady: 'जब आपका ऑर्डर पिकअप के लिए तैयार होगा तो हम आपको सूचित करेंगे',
    orderIsReady: 'आपका ऑर्डर पिकअप के लिए तैयार है',
    thanksForOrdering: 'हमारी सेवा का उपयोग करने के लिए धन्यवाद',
    toPay: 'भुगतान करें',
    letOrder: 'मेनू पेज पर जाएँ और अभी ऑर्डर शुरू करें',
    noTransaction: 'कोई लेनदेन नहीं',
    menulists: 'मेनू सूची',
    editPersonalDetails: 'विवरण संपादित करें',
    trackOrder: 'ऑर्डर ट्रैकिंग',
    myAccount: 'मेरा खाता',
    cart: 'कार्ट',
    helpCenter: 'सहायता केंद्र',
    allPurchaseHistory: 'खरीद इतिहास',
    purchaseHistory: 'खरीद इतिहास',
    personalInfo: 'व्यक्तिगत विवरण',
    cutlery: 'कटलरी',
    km: 'किमी',
    totalAmountSum: 'कुल',
    selectedItemList: 'चयनित आइटम',
    iAm: 'मैं हूँ',
    orderedBy: 'ऑर्डर किया',
    shareQRtoFriend: 'QR Code साझा करें',
    share: 'साझा करें',
    hasItemInBasket: 'बास्केट में आइटम हैं',
    hasItemInBasketDespt: 'उन्हें किचन में भेजना न भूलें',
    updatedAtQR: 'अपडेट किया गया',
    orderSent: 'ऑर्डर किचन में भेजा गया',
    orderSentDespt: 'रेस्तरां आपका खाना तैयार कर रहा है',
    checkGramdTotalIn: 'आप कुल राशि यहाँ देख सकते हैं',
    vatNotInclude: 'इस मूल्य में कर, सेवा शुल्क और छूट शामिल नहीं हैं',
    accept: 'स्वीकार करें',
    termOfService: 'सेवा की शर्तें',
    onPending: 'लंबित',
    OnSuccessOrder: 'सफल',
    prepareingOrder: 'ऑर्डर तैयार हो रहा है',
    deliveringOrder: 'ऑर्डर डिलीवर हो रहा है',
    pickupOrderReady: 'पिक-अप के लिए तैयार',
    pickedupOrder: 'ऑर्डर पिक-अप हो गया',
    deliveredOrder: 'ऑर्डर डिलीवर हो गया',
    shopReceivedOrder: 'दुकान ने ऑर्डर प्राप्त किया',
    orderId: 'ऑर्डर ID',
    orderDetails: 'ऑर्डर विवरण',
    deliveryFee: 'डिलीवरी शुल्क',
    searchDriver: 'ड्राइवर खोज रहे हैं',
    driverFrom: 'ड्राइवर',
    change: 'बदलें',
    deliveryAddress: 'डिलीवरी पता',
    location: 'स्थान',
    addressName: 'पते का नाम',
    addressNameDespt: 'उदा., कॉन्डो नाम, विलेज नाम',
    addressDescription: 'पता विवरण',
    addressDescriptionDespt: 'उदा., बिल्डिंग नंबर, गली',
    noteToDriver: 'ड्राइवर के लिए नोट',
    noteToDriverDespt: 'उदा. प्रवेश द्वार पर टेबल पर रखें',
    inputAddressForm: 'डिलीवरी पता दर्ज करें',
    plsPinAddress: 'अपना स्थान पिन करें',
    pinLocation: 'डिलीवरी स्थान पिन करें',
    createNewAddress: 'नया पता बनाएँ',
    savedAddress: 'सहेजा गया पता',
    phoneNumber: 'फ़ोन नंबर',
    noRequired: 'वैकल्पिक',
    resendCode: 'कोड पुनः भेजें',
    didNotGetCode: 'कोड नहीं मिला?',
    resendIn: 'पुनः भेजें',
    next: 'अगला',
    createAccount: 'खाता बनाएँ',
    createAccountDespt: 'जारी रखने के लिए नीचे फ़ॉर्म भरें',
    sendCodeViaSMS: 'SMS से कोड भेजें',
    inputOTP: 'OTP दर्ज करें',
    inputOTPDespt: 'कृपया भेजा गया 6-अंकों का कोड दर्ज करें',
    termAndPolicy: 'नियम और नीति',
    termAndPolicy1: 'हमारी सेवा का उपयोग करके, आप सहमत हैं',
    termAndPolicy2: 'पूर्ण नियम और नीति पढ़ने के लिए क्लिक करें',

    loginWithPhoneNumber: 'फ़ोन नंबर से लॉगिन',
    loginWithPhoneNumberDespt: 'पहचान सत्यापन के लिए OTP प्राप्त करने हेतु अपना फ़ोन नंबर दर्ज करें',
    backToOrder: 'मेनू पर वापस',
    PaymentMethod: 'भुगतान',
    paymentAmount: 'भुगतान राशि',
    paymentConfirmation: 'भुगतान की पुष्टि',
    cancelPayment: 'भुगतान रद्द करें',
    paidSuccess: 'भुगतान पूर्ण',
    haveNotPurchased: 'अभी तक खरीदारी नहीं की',
    haveNotPurchased2: 'भुगतान विफल होने पर, कृपया स्टाफ से संपर्क करें',
    canNotOrderItem: 'भुगतान करते समय आप खाना ऑर्डर नहीं कर सकते',
    checkPaymentStatus: 'स्थिति जाँचें',
    pendingPayment: 'भुगतान लंबित',
    askForReceipt: 'यदि आपको रसीद चाहिए, तो कृपया स्टाफ से संपर्क करें',
    paymentSuccess: 'भुगतान सफल',
    summaryPayment: 'सारांश',
    numberOfGuest: 'मेहमानों की संख्या',
    closeTab: 'बंद करें',
    addCredit: 'क्रेडिट कार्ड जोड़ें',
    QRPayment: 'QR भुगतान',
    cardPayment: 'क्रेडिट कार्ड',
    payWithStaff: 'काउंटर पर भुगतान करें',
    selectPaymentMethod: 'भुगतान विधि चुनें',
    checkOut: 'चेक आउट',
    startOrderBeforeCallStaff: 'कृपया स्टाफ को बुलाने से पहले ऑर्डर करें',
    basket: 'बास्केट',
    spoon: 'कटलरी का अनुरोध',
    knife: 'चाकू का अनुरोध',
    chopstick: 'चॉपस्टिक का अनुरोध',
    cup: 'कप का अनुरोध',
    plate: 'प्लेट का अनुरोध',
    glass: 'गिलास का अनुरोध',
    payBill: 'बिल का अनुरोध',
    viewAll: 'सभी देखें',
    recommendMenu: 'अनुशंसित',
    OnSuccess: 'सफल',
    OnPreparing: 'तैयार हो रहा है',
    messageSent: 'कृपया हमारे स्टाफ की प्रतीक्षा करें',
    outOfStock: 'स्टॉक में नहीं',
    QRCode: 'QR Code',
    GenerateQRCode: 'QR Code बनाएँ',
    ForQROrder: 'खाना ऑर्डर करने और इन-स्टोर सेवा माँगने के लिए',
    QROrderDescription: 'आप ग्राहकों के लिए खाना ऑर्डर करने और इन-स्टोर सेवा माँगने के लिए QR Code बना सकते हैं',
    SelectTable: 'टेबल चुनें और मेहमानों की संख्या दर्ज करें।',
    shopname: 'दुकान का नाम',
    numberOfCustomer: 'ग्राहकों की संख्या (व्यक्ति)',
    numberOfCustomerDescription: 'ग्राहकों की संख्या दर्ज करें, न्यूनतम 1 व्यक्ति',
    currentUser: 'उपयोगकर्ता',
    guest: 'मेहमान',
    orderItem: 'ऑर्डर सारांश',
    orderItemNav: 'ऑर्डर सारांश',
    callStaff: 'स्टाफ को बुलाएँ',
    callStaffDialog: 'आपको किस प्रकार की सहायता चाहिए?',
    cutlery: 'कटलरी का अनुरोध',
    seasoning: 'मसाले का अनुरोध',
    refillDrink: 'पेय रिफिल का अनुरोध',
    other: 'अन्य',
    tableNumber: 'टेबल',
    menuList: 'मेनू',
    selectedItem: 'खाना ऑर्डर करें',
    selectedItemNav: 'खाना ऑर्डर करें',
    checkOrderBeforeConfirm: 'कृपया रेस्तरां में भेजने से पहले अपने ऑर्डर विवरण और कुल की पुष्टि करें',
    checkOrderBeforeConfirm2: '',
    startOrder: 'ऑर्डर शुरू करें',
    foodCategory: 'श्रेणी',
    searchByName: 'नाम से उत्पाद खोजें...',
    noPreduct: 'कोई उत्पाद उपलब्ध नहीं',
    noSelectedProduct: 'कोई चयनित आइटम नहीं',
    noSelectedProductDespt: 'यदि आपने उत्पाद चुने हैं, तो आपकी चयनों की सूची इस पृष्ठ पर प्रदर्शित होगी',
    backToMenu: 'मेनू पर जाएँ',
    removeSelected: 'क्या आप इस आइटम को हटाना चाहते हैं?',
    confirmOrder: 'ऑर्डर जमा करें',
    endOfTransection: 'लेनदेन समाप्त',
    endOfTransectionDialog: 'उपयोग में समस्या होने पर, कृपया स्टाफ से संपर्क करें',
    note: 'नोट',
    orderTime: 'ऑर्डर का समय',
    orderMoreFood: 'मुख्य मेनू पर वापस',
    orderPreparing: 'हमारे शेफ आपका भोजन तैयार कर रहे हैं। कृपया थोड़ा इंतजार करें। आपका खाना जल्द ही परोसा जाएगा',
    orderPreparing2: '',
    sendingOrder: 'आपका ऑर्डर किचन में भेजा जा रहा है...',
    login: 'लॉगिन',
    forgetPassword: 'पासवर्ड भूल गए',
    loginWithGmail: 'Gmail से लॉगिन',
    or: 'या',
    loginAsStaff: 'स्टाफ के रूप में लॉगिन',
    billOrder: 'बिल',
    table: 'टेबल',
    billOrderDialog: 'मेनू देखने और ऑर्डर करने के लिए QR Code स्कैन करें',
    billOrderDialog2: 'उपयोग में समस्या होने पर, कृपया स्टाफ से संपर्क करें',
    selectTableAleart: 'QR Code बनाने से पहले कृपया टेबल चुनें',
    emptyCartDialog: 'कोई लेनदेन नहीं',
    emptyCartDialogDespt: 'यदि आप ऑर्डर की पुष्टि करते हैं, तो ऑर्डर की गई वस्तुओं की सूची इस पृष्ठ पर प्रदर्शित होगी',
    served: 'परोसा गया',
    contactOurStaff: 'हमारे स्टाफ से संपर्क करें',
    contactOurStaff2: 'सहायता के लिए',
    addToCart: 'कार्ट में जोड़ें',
    noteToShop: 'दुकान के लिए नोट',
    addYourRequest: 'अपना अनुरोध जोड़ें',
    branchName: 'शाखा का नाम',
    businessType: 'व्यवसाय प्रकार',
    taxID: 'कर ID',
    vat: 'कर',
    exclusive: 'कर रहित',
    inclusive: 'कर सहित',
    serviceCharge: 'सेवा शुल्क',
    address: 'पता',
    address1: 'पता पंक्ति 1',
    address2: 'पता पंक्ति 2',
    tel: 'फ़ोन',
    businessType1: 'सामान्य',
    businessType2: 'रेस्तरां',
    businessType3: 'हॉस्टल',
    shopopen: 'खुला - बंद',
    open: 'खुला',
    closed: 'बंद',
    languagetxt: 'भाषा',
    language: 'भाषा और समय क्षेत्र',
    languageTH: 'थाई',
    languageEN: 'अंग्रेज़ी',
    setting: 'सेटिंग',
    shop: 'दुकान',
    timezone: 'समय क्षेत्र',
    deliveryProviders: 'डिलीवरी प्रदाता',
    adddeliveryProviders: 'प्रदाता जोड़ें',
    lastUpdate: 'अंतिम अपडेट',
    logo: 'लोगो',
    updateData: 'डेटा अपडेट करें',
    submit: 'जमा करें',
    cancel: 'रद्द करें',
    normal: 'सामान्य',
    loading: 'लोड हो रहा है...',
    editing: 'संपादन',
    confirmUpdate: 'क्या आप डेटा अपडेट करना चाहते हैं?',
    selectedShoptype: 'व्यवसाय प्रकार चुनें...',
    selectshop: 'शाखा का नाम चुनें',
    save: 'सहेजें',
    reporttxt: 'रिपोर्ट',
    general: 'सामान्य',
    signOut: 'साइन आउट',
    registration: '',
    unit: 'इकाई',
    category: 'श्रेणी',
    product: 'उत्पाद',
    export: 'निर्यात',
    exportKBank: 'K-Bank निर्यात',
    date: 'तिथि',
    to: 'तक',
    status: 'स्थिति',
    vatAmount: 'कर',
    netTotalNonVAT: 'कुल (कर रहित)',
    receiptNumber: 'रसीद संख्या',
    grandTotal: 'कुल योग',
    netAmountVATTotal: 'उप-कुल',
    netTotalIncVAT: 'कुल (कर सहित)',
    proofOfPayment: 'भुगतान का प्रमाण',
    paymentType: 'भुगतान प्रकार',
    paymentType0: 'नकद',
    paymentType1: 'क्रेडिट कार्ड',
    paymentType2: 'कूपन',
    paymentType3: 'Quickpay',
    paymentType4: 'Promptpay',
    paymentType5: 'Alipay',
    paymentType6: 'जमा',
    paymentType7: 'डिलीवरी',
    paymentType8: 'ऑनलाइन',
    paymentType9: 'Line Pay',
    paymentType10: 'कस्टम भुगतान',
    paymentType12: 'KBank',
    paid: 'भुगतान राशि',
    sentSuccessfully: 'सफलतापूर्वक भेजा गया',
    pluCode: 'बारकोड',
    netAmount: 'शुद्ध कुल',
    discount: 'छूट',
    timeOfOrder: 'ऑर्डर का समय',
    orderDate: 'ऑर्डर की तिथि',
    preparing: 'तैयार हो रहा है',
    paymentDetail: 'भुगतान विवरण',
    orderNumber: 'ऑर्डर संख्या',
    delivered: 'नियत तिथि',
    deliveredDate: 'लीड टाइम',
    payment: 'भुगतान',
    productName: 'उत्पाद का नाम',
    quantity: 'मात्रा',
    priceUnit: 'मूल्य/इकाई',
    baht: 'बाट',
    profit: 'लाभ',
    sales: 'बिक्री',
    billAmount: 'बिल कुल',
    total: 'कुल',
    bill: 'बिल',
    discountAmount: 'छूट राशि',
    averageBill: 'औसत/बिल',
    voidbillTotal: 'रद्द बिल कुल',
    salesByDaily: 'दैनिक बिक्री',
    salesByMonth: 'मासिक बिक्री',
    bestSellers: 'बेस्टसेलर',
    bestSellerstype: 'बेस्टसेलर श्रेणी',
    salesBydate: 'तिथि अनुसार बिक्री',
    number: 'क्र.',
    categoryName: 'श्रेणी का नाम',
    newOrder: 'ऑर्डर भेजा गया',
    reject: 'अस्वीकार',
    inProgressTime: 'प्रगति समय',
    rejectTime: 'अस्वीकार समय',
    cancelTime: 'रद्द समय',
    cause: 'कारण',
    preparingToShip: 'तैयार हो रहा है',
    totalAmount: 'कुल',
    order: 'ऑर्डर',
    deposit: 'जमा',
    billSave: 'सहेजें',
    ReceivingOrder: 'टेबल खोलें/ऑर्डर प्राप्त करें',
    orderNo: 'ऑर्डर नं.',
    remark: 'टिप्पणी',
    receiptStatus: 'रसीद स्थिति',
    back: 'वापस',
    detail: 'विवरण',
    countSales: 'मात्रा',
    onhandQty: 'शेष',
    stdCost: 'लागत',
    employees: 'कर्मचारी',
    employeesname: 'कर्मचारी का नाम',
    salesTotal: 'बिक्री कुल',
    totalBill: 'कुल बिल संख्या',
    billActive: 'बिक्री बिल संख्या',
    billVoice: 'रद्द बिल संख्या',
    billDeposit: 'जमा बिल संख्या',
    discountItem: 'कुल आइटम छूट',
    billDiscountAmount: 'कुल बिल छूट',
    billDiscount: 'छूट बिल संख्या',
    payTotal: 'भुगतान कुल',
    deliveryProvider: 'डिलीवरी प्रदाता',
    deliveryDetail: 'डिलीवरी विवरण',
    customDetail: 'कस्टम भुगतान विवरण',
    customPaymentName: 'कस्टम भुगतान नाम',
    firstInvoiceNO: 'पहला बिल नं.',
    lastInvoiceNO: 'अंतिम बिल नं.',
    roundNo: 'राउंड नं.',
    closeAt: 'बंद होने का समय',
    closeBy: 'बंद किया',
    totalCashSales: 'कुल नकद बिक्री',
    initialChange: 'प्रारंभिक छुट्टा',
    totalCashIn: 'कुल नकद आवक',
    totalCashOut: 'कुल नकद जावक',
    actualInDrawer: 'ड्रॉअर में वास्तविक',
    expectedInDrawer: 'ड्रॉअर में अपेक्षित',
    difference: 'अंतर',
    voidBillDetail: 'रद्द बिल विवरण',
    cancelBy: 'रद्द किया',
    cancelDate: 'रद्द तिथि',
    searchByEmployees: 'कर्मचारी से खोजें',
    search: 'खोजें',
    timeIn: 'आगमन',
    timeOut: 'प्रस्थान',
    time: 'समय',
    hours: 'घंटे',
    seconds: 'सेकंड',
    netTotal: 'कुल',
    reason: 'कारण',
    searchByProduct: 'उत्पाद से खोजें',
    sortBy: 'क्रमबद्ध करें',
    last: 'नवीनतम',
    price: 'उत्पाद मूल्य',
    sortByNumMin: 'न्यूनतम मूल्य',
    sortByNumMax: 'अधिकतम मूल्य',
    documentNo: 'दस्तावेज़ नं.',
    transactionType: 'लेनदेन प्रकार',
    updatedBy: 'अपडेट किया',
    transactionType1: 'बिक्री',
    transactionType2: 'वापसी',
    transactionType3: 'स्टॉक इन',
    transactionType4: 'स्टॉक आउट',
    transactionType5: 'स्टॉक समायोजन इन',
    transactionType6: 'स्टॉक समायोजन आउट',
    transactionType7: 'पॉइंट रिडीम',
    transactionType8: 'स्टॉक इन हटाएँ',
    transactionType9: 'स्टॉक आउट हटाएँ',
    transactionType10: 'स्टॉक इन संपादन',
    transactionType11: 'स्टॉक आउट संपादन',
    billNo: 'बिल नं.',
    docTotal: 'कुल',
    customer: 'ग्राहक',
    username: 'उपयोगकर्ता नाम',
    dateOfBill: 'बिल की तिथि',
    selectDate: 'तिथि चुनें',
    dialogSelectCategory: 'कृपया खोज के लिए श्रेणी चुनें',
    dialogUpdateDocumentSuccess: 'दस्तावेज़ सफलतापूर्वक अपडेट हुआ',
    dialogfound: 'दर्ज की गई जानकारी गलत है।',
    isVatIncluded: 'क्या VAT शामिल है',
    vatIccludes: 'VAT',
    confirmStock: 'स्टॉक की पुष्टि करें',
    confirm: 'पुष्टि करें',
    deleteDoc: 'दस्तावेज़ हटाएँ',
    confirmUpdateDocModal: 'क्या आप स्टॉक दस्तावेज़ अपडेट करना चाहते हैं?',
    confirmSaveDoc: 'दस्तावेज़ सहेजने की पुष्टि',
    confirmDeleteDoc: 'दस्तावेज़ हटाने की पुष्टि',
    confirmDeleteModal: 'क्या आप स्टॉक दस्तावेज़ हटाना चाहते हैं?',
    dialogSaveDocumentSuccess: 'दस्तावेज़ सफलतापूर्वक सहेजा गया',
    createStockIn: 'स्टॉक-इन बनाएँ',
    confirmSaveDocModal: 'क्या आप स्टॉक दस्तावेज़ सहेजना चाहते हैं?',
    selectShopPlease: 'कृपया दुकान चुनें',
    selectProductPlease: 'कृपया उत्पाद चुनें',
    duplicateProduct: 'आपने यह आइटम पहले ही चुन लिया है।',
    productInvilid: 'आपके द्वारा चुना गया आइटम अमान्य है। कृपया सिस्टम प्रशासक से संपर्क करें।',
    confirmStockOut: 'स्टॉक आउट की पुष्टि',
    dialogSaveDocumentOutSuccess: 'दस्तावेज़ सफलतापूर्वक सहेजा गया',
    confirmSaveDocStockOutModal: 'क्या आप स्टॉक आउट दस्तावेज़ सहेजना चाहते हैं?',
    adjustDocType: 'समायोजन दस्तावेज़ प्रकार',
    adjustDocType1: 'बढ़ाएँ',
    adjustDocType2: 'घटाएँ',
    beforeAdjust: 'स्टॉक समायोजन से पहले',
    afterAdjust: 'स्टॉक समायोजन के बाद',
    adjust: 'स्टॉक समायोजन',
    createDoucument: 'दस्तावेज़ बनाएँ',
    transferType: 'ट्रांसफर प्रकार',
    transferType1: 'ट्रांसफर इन',
    transferType2: 'ट्रांसफर आउट',
    new: 'नया',
    finish: 'समाप्त',
    refDocument: 'संदर्भ दस्तावेज़',
    statusDoc: 'दस्तावेज़ स्थिति',
    dialogSaveTransferDocumentSuccess: 'ट्रांसफर दस्तावेज़ सफलतापूर्वक बनाया गया',
    destinationShop: 'गंतव्य दुकान',
    destinationShopBranch: 'गंतव्य शाखा',
    sourceBranch: 'स्रोत शाखा',
    sourceShop: 'स्रोत दुकान',
    sourceAddress: 'स्रोत पता',
    destinationAddress: 'गंतव्य पता',
    saveTransfer: 'स्टॉक ट्रांसफर सहेजें',
    confirmSaveTransfer: 'क्या आप स्टॉक ट्रांसफर सहेजना चाहते हैं?',
    savinserviceChargegDoc: 'दस्तावेज़ सहेज रहे हैं',
    selectdestinationPlease: 'कृपया गंतव्य शाखा चुनें',
    validatedestinationproduct: "गंतव्य शाखा में यह उत्पाद नहीं है",
    validateProduct: 'कृपया उत्पाद चुनें',
    created_by: 'द्वारा',
    receive: 'प्राप्त करें',
    updateDoc: 'दस्तावेज़ अपडेट करें',
    cancelDoc: 'दस्तावेज़ रद्द करें',
    confirmCancelDoc: 'क्या आप यह दस्तावेज़ रद्द करना चाहते हैं?',
    cancelingDoc: 'दस्तावेज़ रद्द हो रहा है',
    updatingDoc: 'दस्तावेज़ अपडेट हो रहा है',
    updateDocFail: "दस्तावेज़ अपडेट नहीं हो सका",
    cancelDocSuccess: 'दस्तावेज़ रद्द हो गया',
    cancelDocFail: "दस्तावेज़ रद्द नहीं हो सका",
    refDocumentTransfer: 'संदर्भ दस्तावेज़',
    comfrimTransferIn: 'ट्रांसफर स्टॉक इन की पुष्टि',
    dilogcomfrimTransferIn: 'क्या आप ट्रांसफर स्टॉक इन दस्तावेज़ चाहते हैं?',
    transferInDetail: 'ट्रांसफर स्टॉक विवरण',
    totalNet: 'शुद्ध कुल',
    confirmAdjust: 'स्टॉक समायोजन की पुष्टि',
    createStockOut: 'स्टॉक आउट बनाएँ',
    favorite: 'पसंदीदा',
    isOnScreen: 'स्क्रीन पर दिखाएँ',
    negotiatePrice: 'मूल्य वार्ता',
    productTypeP: 'सामान्य उत्पाद',
    productTypeBOM: 'सामग्री सूची',
    productTypeSN: 'सीरियल उत्पाद',
    productTypeSV: 'सेवा (गैर-स्टॉक)',
    productPLU: 'अन्य पैकेजिंग आकार',
    productBOM: 'सामग्री',
    productSN: 'Serial Number',
    morePrice: 'अन्य मूल्य',
    cost: 'लागत',
    quantityPrice: 'मात्रा',
    exceedUc: 'मूल्य',
    changeImg: 'चित्र बदलें',
    addProduct: 'उत्पाद जोड़ें',
    selectImg: 'चित्र चुनें',
    deleteImg: 'चित्र हटाएँ',
    selectImgFromPC: 'PC से चित्र चुनें',
    confirmSaveImgDialog: 'क्या आप उत्पाद सहेजना चाहते हैं?',
    confirmSaveImg: 'उत्पाद सहेजने की पुष्टि',
    addPrice: 'मूल्य जोड़ें',
    editPrice: 'मूल्य संपादित करें',
    dialigDeleteProduct: 'क्या आप उत्पाद हटाना चाहते हैं?',
    confirmDeleteProduct: 'इस उत्पाद को हटाने की पुष्टि',
    productType: 'उत्पाद प्रकार',
    countProduct: 'उत्पाद संख्या',
    addUnit: 'इकाई जोड़ें',
    editUnit: 'इकाई संपादित करें',
    active: 'सक्रिय',
    inactive: 'निष्क्रिय',
    confirmSaveUnitDialog: 'क्या आप इकाई सहेजना चाहते हैं?',
    confirmSaveUnit: 'इस इकाई को सहेजने की पुष्टि',
    dialigDeleteUnit: 'क्या आप इकाई हटाना चाहते हैं?',
    confirmDeletUnit: 'इस इकाई को हटाने की पुष्टि',
    confirmSaveCategoryDialog: 'क्या आप श्रेणी सहेजना चाहते हैं?',
    confirmSaveCategory: 'इस श्रेणी को सहेजने की पुष्टि',
    dialigDeleteCategory: 'क्या आप श्रेणी हटाना चाहते हैं?',
    confirmDeletCategory: 'श्रेणी हटाने की पुष्टि',
    addCategory: 'श्रेणी जोड़ें',
    editCategory: 'श्रेणी संपादित करें',
    bgColor: 'पृष्ठभूमि रंग',
    selectbgColor: 'पृष्ठभूमि रंग चुनें',
    validateCategoryname: 'कृपया श्रेणी का नाम दर्ज करें।',
    sequence: 'क्रम',
    enterProduct: 'कृपया उत्पाद का नाम दर्ज करें।',
    enterPrice: 'कृपया उत्पाद का मूल्य दर्ज करें।',
    selectCategory: 'कृपया उत्पाद श्रेणी चुनें।',
    selectUnit: 'कृपया उत्पाद इकाई चुनें।',
    confirmSaveProduct: 'क्या आप यह उत्पाद सहेजना चाहते हैं?',
    confirmSaveProductPrice: 'क्या आप अन्य मूल्य सहेजना चाहते हैं?',
    validatepackQty: 'कृपया मूल्य/इकाई दर्ज करें।',
    validatepackUc: 'कृपया मूल्य दर्ज करें।',
    validatePRU: 'डुप्लिकेट डेटा, कृपया पुनः दर्ज करें।',
    createProductSuccess: 'उत्पाद सफलतापूर्वक बनाया गया',
    addSerial: 'सीरियल जोड़ें',
    add: 'जोड़ें',
    createSerial: 'Serial Number बनाएँ',
    available: 'बिक्री के लिए तैयार',
    soldOut: 'बिक गया',
    deleteSuccess: 'सफलतापूर्वक हटाया गया',
    enterSerial: 'कृपया Serial Number दर्ज करें',
    confirmSaveSerial: 'क्या आप यह Serial Number सहेजना चाहते हैं?',
    confirmDelete: 'क्या आप यह Serial Number हटाना चाहते हैं?',
    addProductPLU: 'पैकेजिंग आकार जोड़ें',
    img: 'चित्र',
    SKURatio: 'अनुपात',
    editProductPLU: 'पैकेजिंग आकार संपादित करें',
    enterSKURatio: 'कृपया अनुपात दर्ज करें',
    comfrimDeletePLU: 'क्या आप यह पैकेजिंग आकार हटाना चाहते हैं?',
    useStepPrice: 'चरण मूल्य उपयोग करें',
    addBOM: 'सामग्री जोड़ें',
    confirmSaveBOM: 'क्या आप सामग्री सहेजना चाहते हैं?',
    user: 'उपयोगकर्ता',
    userDetail: 'उपयोगकर्ता विवरण',
    planDetail: 'प्लान विवरण',
    currentPlan: 'वर्तमान प्लान',
    expireDate: 'समाप्ति तिथि',
    startDate: 'शुरू तिथि',
    dialogSignOut: 'क्या आप साइन आउट करना चाहते हैं?',
    confirmSignOut: 'साइन आउट की पुष्टि',
    countMember: 'कुल सदस्य',
    addMenber: 'सदस्य जोड़ें',
    searchMember: 'नाम, ईमेल और फ़ोन से खोजें',
    dateOfMember: 'सदस्यता तिथि',
    recentVisit: 'हाल की विज़िट',
    memberName: 'सदस्य का नाम',
    email: 'ईमेल',
    paymentTotal: 'भुगतान कुल',
    point: 'पॉइंट',
    pointtxt: 'पॉइंट',
    postalCode: 'पिन कोड',
    saveing: 'सहेज रहे हैं...',
    edit: 'संपादित करें',
    editMember: 'सदस्य संपादित करें',
    deleteing: 'हटा रहे हैं...',
    dialogDeleteMember: 'क्या आप सदस्य हटाना चाहते हैं?',
    confirmDeleteMember: 'हटाने की पुष्टि',
    valtdateMember: 'कृपया जानकारी भरें',
    createMemberSuccess: 'सदस्य सफलतापूर्वक जोड़ा गया!',
    updateMemberSuccess: 'सदस्य सफलतापूर्वक संपादित किया गया!',
    deleteMemberSuccess: 'सदस्य सफलतापूर्वक हटाया गया!',
    onhandQtyMin: 'न्यूनतम स्टॉक',
    onhandQtyMax: 'अधिकतम स्टॉक',
    onhandQtySort: 'स्टॉक मात्रा',
    showProductAll: 'सभी उत्पाद प्रकार',
    updateAt: 'अंतिम अपडेट',
    sortName: 'नाम',
    stockUnit: 'लागत/इकाई',
    deleteCategory: 'श्रेणी हटाएँ',
    selectd: 'चुनें',
    searchProduct: 'उत्पाद खोजें',
    reset: 'रीसेट',
    selectdProduct: 'उत्पाद चुनें',
    information: 'जानकारी',
    adjustStockList: 'स्टॉक समायोजन उत्पाद',
    adjustDetail: 'स्टॉक समायोजन सूची में उत्पाद जोड़ें और सेट करें',
    transferoutList: 'स्टॉक ट्रांसफर उत्पाद',
    addProductTransfer: 'स्टॉक ट्रांसफर सूची में उत्पाद जोड़ें और सेट करें',
    transferDetail: 'स्टॉक आउट सूची में उत्पाद जोड़ें और सेट करें',
    transferinList: 'स्टॉक इन सूची में उत्पाद जोड़ें और सेट करें',
    stockOutList: 'स्टॉक आउट उत्पाद',
    addstockOutList: 'स्टॉक आउट सूची में उत्पाद जोड़ें और सेट करें',
    stockinList: 'स्टॉक इन उत्पाद',
    addProductStockin: 'स्टॉक इन सूची में उत्पाद जोड़ें और सेट करें',
    checkCount: 'स्टॉक जाँचें',
    createAdjustStock: 'स्टॉक समायोजन बनाएँ',
    memberDetail: 'सदस्य जानकारी',
    package: 'पैकेज विवरण',
    startPackate: 'पैकेज शुरू',
    endPackate: 'पैकेज समाप्त',
    name: 'नाम',
    productImg: 'उत्पाद चित्र',
    fistname: 'पहला नाम',
    lastname: 'अंतिम नाम',
    saveMember: 'जानकारी सहेजें',
    confirmSaveMember: 'क्या आप सदस्य सहेजना चाहते हैं?',
    yesOrNo: 'हाँ या नहीं',
    totaValue: 'कुल',
    deleteMember: 'सदस्य हटाएँ',
    frequently: 'बार-बार खरीदे गए उत्पाद',
    recentPurchase: 'अंतिम खरीद',
    paymentDescription: 'भुगतान विवरण',
    validateInfomation: 'कृपया जानकारी दर्ज करें',
    validateTel: 'फ़ोन नंबर गलत है',
    validateOTP: 'OTP गलत है',
    validateEmail: 'ईमेल गलत है',
    saveSuccess: 'सफलतापूर्वक सहेजा गया',
    txtcustomer: 'ग्राहक',
    customerName: 'ग्राहक का नाम',
    customerCount: 'ग्राहक संख्या',
    addCustomer: 'ग्राहक जोड़ें',
    permissionManage: 'अनुमतियाँ',
    mainMenu: 'मुख्य मेनू',
    page: 'पृष्ठ',
    show: 'दिखाएँ',
    delete: 'हटाएँ',
    administratorTools: 'प्रशासक उपकरण',
    deviceName: 'डिवाइस का नाम',
    lastSyncProduct: 'अंतिम सिंक',
    version: 'संस्करण',
    posstatus: 'स्थिति',
    posNumber: 'POS नंबर',
    titleSilomconnect: 'इन सेवाओं से कोई बिक्री न छूटे',
    updateSilom: 'LINE पर दैनिक बिक्री मुफ्त में अपडेट करें',
    addfriend: 'मित्र जोड़ें',
    enterToReciveService: 'सेवा कोड प्राप्त करने के लिए दबाएँ।',
    verifyCodeToUsed: 'सिस्टम का उपयोग शुरू करने के लिए, पहचान सत्यापन कोड प्राप्त करने हेतु दबाएँ।',
    verifyfivemin: 'सत्यापन कोड 5 मिनट तक मान्य है।',
    yourVertify: 'आपका सत्यापन कोड है',
    pressCode: 'कोड प्राप्त करें',
    exCode: 'कोड की समाप्ति',
    sessionEx: 'लॉगिन सत्र समाप्त हो गया। कृपया पुनः लॉगिन करें।',
    refresh: 'रीफ्रेश',
    selectedFile: 'फ़ाइल चुनें',
    fileSize: 'फ़ाइल का आकार 2 MB से अधिक नहीं।',
    isBeingToUsed: 'उपयोग में है',
    notInUse: 'उपयोग में नहीं',
    delete: 'हटाएँ',
    confirmUpdateInformation: 'जानकारी अपडेट की पुष्टि',
    memberCount: 'संख्या',
    orderMachine: 'ऑर्डर डिवाइस',
    textMember: 'सदस्य',
    manageShop: 'दुकान जानकारी प्रबंधन',
    lansetting: 'दुकान भाषा और समय क्षेत्र सेटिंग',
    timezoneSetiing: 'दुकान समय क्षेत्र सेटिंग',
    deliveryProviderSetting: 'दुकान के डिलीवरी प्रदाता',
    toolsSetting: 'दुकान POS मशीन प्रबंधन',
    checkStockPLU: 'उत्पाद शेष < 0',
    searching: 'खोज रहे हैं',
    allProduct: 'सभी उत्पाद',
    foundProductOnhand: 'स्टॉक < 0 वाले उत्पाद मिले',
    confirmAdjustBefor: 'क्या आप सिस्टम से स्वचालित समायोजन चाहते हैं?',
    requireAdjust: 'हाँ',
    imrequireAdjust: 'नहीं',
    islimitItemTodoc: 'आप 200 आइटम / 1 दस्तावेज़ तक चुन सकते हैं।',
    barcodePrint: 'बारकोड प्रिंट',
    printEx: 'प्रिंट और उदाहरण',
    print: 'प्रिंट',
    downloadAndExport: 'डाउनलोड और प्रिंट',
    selectFormat: 'पेपर फॉर्मेट चुनें',
    peperFormat: 'पेपर फॉर्मेट',
    optional: 'वैकल्पिक',
    standardA427: 'A4 मानक: 27 आइटम/पृष्ठ',
    standardA450: 'A4 मानक: 52 आइटम/पृष्ठ',
    standardA460: 'A4 मानक: 60 आइटम/पृष्ठ',
    standardA556: 'A4 मानक: 56 आइटम/पृष्ठ (स्टिकर आकार: A5)',
    standardA550: 'A5 पेपर: 52 आइटम/पृष्ठ',
    standardA560: 'A5 पेपर: 60 आइटम/पृष्ठ',
    countBarcode: 'बारकोड संख्या',
    barcode: 'बारकोड',
    setFontsize: 'फ़ॉन्ट सेटिंग',
    accessPermissionDes: 'उपयोगकर्ताओं को एक्सेस असाइन करें।',
    deleteUser: 'उपयोगकर्ता हटाने की पुष्टि',
    confirmDeleteUser: 'क्या आप उपयोगकर्ता हटाना चाहते हैं?',
    passAtless: 'पासवर्ड कम से कम 6 अक्षर होना चाहिए।',
    inValidPass: 'गलत पासवर्ड',
    createBy: 'द्वारा बनाया',
    adjustAutoDes: "यदि आप सिस्टम को स्वचालित रूप से अपडेट नहीं करना चाहते तो उत्पाद का कुल शेष गलत हो सकता है।",
    addUser: 'उपयोगकर्ता जोड़ें',
    isMenu: 'ग्राहक मेनू पर दिखाएँ',
    menuSmart: 'उत्पाद मेनू सेट करें',
    smartSettingTitle: 'मेनू सेटिंग',
    smartSetting: 'Silom CRM के लिए मेनू सेटिंग',
    confirmEnable: 'क्या आप मेनू सक्षम करना चाहते हैं?',
    confirmDisEnable: 'क्या आप मेनू अक्षम करना चाहते हैं?',
    confirmSelfOrderEnable: 'क्या आप सेल्फ-ऑर्डर मेनू सक्षम करना चाहते हैं?',
    confirmSelfOrderDisable: 'क्या आप सेल्फ-ऑर्डर मेनू अक्षम करना चाहते हैं?',
    enable: 'सक्षम',
    disable: 'अक्षम',
    usabilityStatus: 'सक्षम',
    manageSmartOnProduct: 'आप पेज पर ग्राहक मेनू पर दिखाने के लिए उत्पादों की सूची "जोड़/संपादित" कर सकते हैं।',
    manageSmartOnCategory: 'आप पेज पर ग्राहक मेनू पर दिखाने के लिए श्रेणी सूची "जोड़/संपादित" कर सकते हैं।',
    turnonSmart: 'और मेनू सक्षम करें',
    manageShopDes: 'आप उपयोगकर्ता मैनुअल में संदर्भ ले सकते हैं -',
    desSmartMenu: 'LINE पर E-menu प्रदर्शित करने के लिए उत्पाद मेनू सेट करें ताकि ग्राहक आसानी से एक्सेस कर सकें और स्वयं ऑर्डर कर सकें।',
    link: 'लिंक',
    createTranferOut: 'ट्रांसफर आउट दस्तावेज़ बनाएँ',
    roundingValue: 'राउंडिंग समायोजन',
    limitItems: 'अधिकतम 200 आइटम तक चुन सकते हैं',
    IncomeCategory: 'आय',
    ExpenseCategory: 'व्यय',
    saveBy: 'द्वारा सहेजा',
    saveDate: 'सहेजने की तिथि',
    drawerCate: 'श्रेणियाँ',
    openingHours: 'खुलने का समय',
    shopLocation: 'दुकान का स्थान',
    sunday: 'रविवार',
    monday: 'सोमवार',
    tuesday: 'मंगलवार',
    wednesday: 'बुधवार',
    thursday: 'गुरुवार',
    friday: 'शुक्रवार',
    saturday: 'शनिवार',
    lat: 'अक्षांश',
    lng: 'देशांतर',
    shopCoverSetting: 'दुकान कवर सेटिंग',
    shopCoverSettingDes: 'ग्राहक स्क्रीन पर दिखाने के लिए दुकान कवर सेट करें',
    locationSettingDes: 'स्थान सेटिंग',
    updatelocation: 'स्थान अपडेट करें',
    searchLocation: 'स्थान खोजें',
    imaginaryLine: 'काल्पनिक रेखा',
    openingHoursDes: 'दुकान के खुलने का समय सेट करें',
    paymentDescriptionConfig: 'भुगतान विधि चुनें',
    creditCard: 'क्रेडिट कार्ड',
    promptPay: 'Promptpay',
    coupon: 'कूपन',
    quickpay: 'Krungsri Quick Pay',
    alipay: 'Alipay',
    linepay: 'Rabbit LINE Pay',
    thaidotcom: 'Thai Dot Com Payment',
    mounth: 'महीना',
    dayMY: 'तिथि',
    item: 'आइटम',
    byStockIn: 'स्टॉक-इन',
    stockOutOther: 'अन्य',
    drawerSales: 'बिक्री',
    sumIncomeExpenses: 'आय-व्यय सारांश',
    incomeOther: 'अन्य आय',
    loss: 'हानि',
    grossProfit: 'सकल लाभ',
    newUser: 'नया उपयोगकर्ता',
    userType: 'उपयोगकर्ता प्रकार',
    password: 'पासवर्ड',
    confirmPassword: 'पासवर्ड की पुष्टि करें',
    ParticipatingProducts: 'उत्पाद चुनें',
    descriptionSilomOrder: 'order.silompos.com के लिए उत्पाद चुनें',
    cashierManagement: 'कैशियर प्रबंधन',
    cashierManageButton: 'प्रबंधित करें',
    cashierUsernamePassword: 'कैशियर उपयोगकर्ता नाम और पासवर्ड',
    cashierCRUDDescription: 'order.silompos.com लॉगिन के लिए',
    password: 'पासवर्ड',
    placeholderPassword: 'पासवर्ड दर्ज करें',
    resetPassword: 'पासवर्ड रीसेट करें',
    oldPassword: 'पुराना पासवर्ड',
    oldPasswordPlaceholder: 'पुराना पासवरड दर्ज करें',
    newPassword: 'नया पासवर्ड',
    purchaseDetail: 'खरीद विवरण',
    uploadImage: 'चित्र अपलोड करें',
    keyword: 'कीवर्ड',
    firstname: 'पहला नाम',
    lastname: 'अंतिम नाम',
    province: 'प्रांत',
    district: 'जिला',
    subdistrict: 'उपजिला',
    addressNumber: 'पता',
    setAsDefaultAddress: 'डिफ़ॉल्ट पता के रूप में सेट करें',
    setAsTaxAddress: 'कर पता के रूप में सेट करें',
    setAsShippingAddress: 'शिपिंग पता के रूप में सेट करें',
    contact: 'संपर्क',
    setAsDefault: 'डिफ़ॉल्ट के रूप में सेट करें',
    addressLists: 'पता सूची',
    default: 'डिफ़ॉल्ट',
    taxAddress: 'कर चालान',
    shippingAddress: 'शिपिंग',
    addAddress: 'जोड़ें',
    createdAt: 'बनाया गया',
    updatedAt: 'अपडेट किया गया',
    by: 'द्वारा',
    readyForSale: 'बिक्री के लिए तैयार',
    sold: 'बिका',
    delete: 'हटाएँ',
    items: 'आइटम',
    itemDiscount: 'आइटम छूट',
    failedToSave: 'सहेजने में विफल!',
    dateOfBirth: 'जन्म तिथि',
    menu: 'मेनू',
    dashboardMenu: 'डैशबोर्ड',
    transactionMenu: 'लेनदेन',
    currentBillMenu: 'वर्तमान बिल',
    reportMenu: 'रिपोर्ट',
    orderDeviceMenu: 'ऑर्डर डिवाइस',
    memberMenu: 'सदस्य',
    inventoryMenu: 'इन्वेंटरी',
    productMenu: 'उत्पाद',
    selfOrderMenu: 'बिक्री चैनल',
    settingMenu: 'सेटिंग',
    salesReportByDate: 'तिथि अनुसार बिक्री',
    salesReportByBill: 'बिल अनुसार बिक्री',
    salesQuantitySummaryByProductReport: 'उत्पाद अनुसार बिक्री',
    quantitySummaryByPLUReport: 'उत्पाद अनुसार बिक्री (PLU)',
    nonSellingProduct: 'न बिकने वाले उत्पाद',
    salesSummaryByCashierReport: 'कैशियर अनुसार बिक्री',
    salesSummaryByCategoryReport: 'श्रेणी अनुसार बिक्री',
    paymentReport: 'भुगतान',
    salesTaxReport: 'बिक्री कर',
    drawerReport: 'ड्रॉअर',
    voidBillReport: 'रद्द बिल',
    timesheetReport: 'टाइमशीट',
    stockInByListReport: 'उत्पाद अनुसार स्टॉक इन',
    stockOutByListReport: 'उत्पाद अनुसार स्टॉक आउट',
    nonAdjustStockProductReport: 'असमायोजित स्टॉक उत्पाद',
    exportProductReport: 'उत्पाद निर्यात',
    salesSummaryByOrderReport: 'ऑर्डर डिवाइस अनुसार',
    salesSummaryProductByOrderReport: 'उत्पाद अनुसार',
    voidBillByOrderReport: 'रद्द बिल',
    inventoryReport: 'इन्वेंटरी रिपोर्ट',
    inventoryReportByPLU: 'PLU अनुसार इन्वेंटरी रिपोर्ट',
    inventoryReportBySerial: 'Serial No. अनुसार इन्वेंटरी रिपोर्ट',
    stockMovement: 'स्टॉक मूवमेंट',
    stockInDocument: 'स्टॉक-इन दस्तावेज़',
    stockOutDocument: 'स्टॉक-आउट दस्तावेज़',
    adjustStockDocument: 'स्टॉक समायोजन दस्तावेज़',
    selfOrder: 'सेल्फ ऑर्डर',
    cashier: 'कैशियर',
    permission: 'अनुमतियाँ',
    menuSetting: 'मेनू सेटिंग',
    management: {
        txtManagement: 'प्रबंधन',
        user: 'खाता',
        shopBranch: 'दुकान और शाखा',
        productManagement: 'उत्पाद',
        unitManagement: 'इकाई',
        categorytManagement: 'श्रेणी',
        inventory: 'इन्वेंटरी',
        stockIn: 'स्टॉक-इन',
        stockOut: 'स्टॉक-आउट',
        adjustStock: 'स्टॉक समायोजन',
        checkStock: 'स्टॉक जाँच',
        stockMovement: 'स्टॉक मूवमेंट',
        transferStock: 'स्टॉक ट्रांसफर',
        reportByPLU: 'PLU अनुसार इन्वेंटरी रिपोर्ट',
        reportBySKU: 'इन्वेंटरी रिपोर्ट',
        txtreportBySKU: 'इन्वेंटरी रिपोर्ट',
        txtreportByPLU: 'PLU अनुसार इन्वेंटरी रिपोर्ट',
        stockInDoc: 'स्टॉक-इन दस्तावेज़',
        stockOutDoc: 'स्टॉक-आउट दस्तावेज़',
        adjustStockDoc: 'स्टॉक समायोजन दस्तावेज़',
        transferStockDoc: 'स्टॉक ट्रांसफर दस्तावेज़',
        transferStockInDoc: 'ट्रांसफर स्टॉक इन दस्तावेज़',
        transferStockOutDoc: 'ट्रांसफर स्टॉक आउट दस्तावेज़',
    },
    report: {
        dashboard: 'डैशबोर्ड',
        transaction: 'लेनदेन',
        currentbill: 'वर्तमान बिल',
        daily: 'तिथि अनुसार',
        txtdaily: 'तिथि अनुसार बिक्री रिपोर्ट',
        dailyDes: 'तिथि अनुसार बिक्री रिपोर्ट विवरण',
        sellbyProduct: 'बिल विवरण अनुसार',
        txtsellbyProduct: 'बिल विवरण अनुसार बिक्री रिपोर्ट',
        sku: 'उत्पाद अनुसार',
        txtsku: 'उत्पाद अनुसार बिक्री रिपोर्ट',
        plu: 'उत्पाद अनुसार (PLU)',
        textPlu: 'उत्पाद अनुसार बिक्री रिपोर्ट (PLU)',
        paymentreport: 'भुगतान रिपोर्ट',
        txtpaymentreport: 'भुगतान रिपोर्ट',
        timesheet: 'टाइमशीट',
        txtTimesheet: 'टाइमशीट रिपोर्ट',
        unsell: 'न बिकने वाले उत्पाद',
        txtUnsell: 'न बिकने वाले उत्पाद',
        byCategory: 'श्रेणी अनुसार',
        txtbyCategory: 'श्रेणी अनुसार बिक्री रिपोर्ट',
        byCashier: 'कैशियर अनुसार',
        txtbyCashier: 'कैशियर अनुसार बिक्री रिपोर्ट',
        salesTax: 'बिक्री कर रिपोर्ट',
        txtSalesTax: 'बिक्री कर रिपोर्ट',
        voidbill: 'रद्द बिल',
        txtvoidbill: 'रद्द बिल रिपोर्ट',
        closedSale: 'बिक्री बंद',
        txtCloseSale: 'ड्रॉअर रिपोर्ट',
        salesByOrder: 'बिक्री सारांश',
        productByOrder: 'उत्पाद अनुसार',
        unsalesByOrder: 'रद्द बिल',
        txtDeliveryRoport: 'डिलीवरी भुगतान रिपोर्ट',
        txtCustomReport: 'कस्टम भुगतान रिपोर्ट',
        txtSalesByOrder: 'ऑर्डर डिवाइस अनुसार उत्पाद बिक्री',
        txtDailyOrder: 'ऑर्डर डिवाइस अनुसार बिक्री रिपोर्ट',
        txtViodOrder: 'ऑर्डर डिवाइस अनुसार रद्द बिल',
        nonadjust: 'असमायोजित स्टॉक उत्पाद',
        txtnonadjust: 'असमायोजित स्टॉक उत्पाद रिपोर्ट',
        stockInReport: 'उत्पाद अनुसार स्टॉक इन रिपोर्ट',
        stockOutReport: 'उत्पाद अनुसार स्टॉक आउट रिपोर्ट',
        stockIn: 'उत्पाद अनुसार स्टॉक इन',
        stockOut: 'उत्पाद अनुसार स्टॉक आउट',
        exportProduct: 'उत्पाद निर्यात',
        txtExportProduct: 'उत्पाद निर्यात रिपोर्ट',
        cashDrawer: 'ड्रॉअर',
        txtCashDrawerr: 'नकद प्रबंधन रिपोर्ट',
        cashRevenue: 'नकद राजस्व',
    },
    drawer: {
        cashDrawer: 'ड्रॉअर',
        txtCashDrawerr: 'नकद प्रबंधन रिपोर्ट',
        cashRevenue: 'आय-व्यय सारांश',
        txtcashRevenue: 'आय-व्यय सारांश रिपोर्ट',
    },
    member: {
        txtmember: 'सदस्य',
        register: 'दुकान पंजीकरण (LINE OA)',
        loyaltyPoint: 'लॉयल्टी पॉइंट',
        storeCredit: 'स्टोर क्रेडिट',
        deal: 'डील',
        giftVoucher: 'गिफ्ट वाउचर',
        referral: 'आमंत्रित करें',
        crm: 'Silom CRM',
    },
    unableStockDescription: 'दस्तावेज़ बनने के बाद स्टॉक अपडेट होने के कारण उत्पाद संपादित नहीं किया जा सकता।',
    noItem: 'कोई आइटम नहीं',
    enterProductName: 'उत्पाद का नाम दर्ज करें',
    ByCategory: 'श्रेणी अनुसार',
    ByCategoryDetail: 'श्रेणी विवरण अनुसार',
    maximum: 'अधिकतम',
    selectZone: 'ज़ोन चुनें',
    minimum: 'न्यूनतम',
    unlimited: 'असीमित',
    startTime: 'शुरू का समय',
    endTime: 'समाप्ति का समय',

    "errorMessages": {
        "qrExpired": "QR Code समाप्त",
        "qrNotFound": "QR Code नहीं मिला",
        "paymentSuccess": "भुगतान सफल",
        "invalidQrType": "अमान्य QR Code प्रकार",
        "tableMoved": "टेबल स्थानांतरित",
        "receiptVoided": "रसीद रद्द कर दी गई"
    },
    "errorDescriptions": {
        "qrExpired": "आपके द्वारा उपयोग किया गया QR Code समाप्त हो गया है।<br>कृपया सहायता के लिए हमारे स्टाफ से संपर्क करें।",
        "qrNotFound": "खाना ऑर्डर करने के लिए QR Code जानकारी नहीं मिली।<br>कृपया हमारे स्टाफ से संपर्क करें।",
        "paymentSuccess": "हमारी सेवा का उपयोग करने के लिए धन्यवाद!",
        "invalidQrType": "कृपया डायनामिक QR Code प्राप्त करने के लिए स्टाफ से संपर्क करें।",
        "tableMoved": "कृपया नया QR Code प्राप्त करने के लिए स्टाफ से संपर्क करें।",
        "receiptVoided": "हमारी सेवा का उपयोग करने के लिए धन्यवाद।<br>यदि आपको सहायता चाहिए तो कृपया स्टाफ से संपर्क करें।"
    },
    waitForServe: 'सर्विंग की प्रतीक्षा',
    DineInPaymentDetails: 'भुगतान',
    silomPayProDesp: 'Silom Pay Easy द्वारा सुरक्षित भुगतान',
    billDetail: 'बिल विवरण',
    minute: 'मिनट',
    paymentTImeExpired: 'समय समाप्त',
    openApp: 'ऐप खोलें',
    callPayStaffSuccess: 'स्टाफ को बुलाया गया<br>कृपया भुगतान पूरा करने के लिए प्रतीक्षा करें',
    account: 'खाता',
    refNumber: 'संदर्भ नं.',
    QRCodeBBL: 'क्रेडिट कार्ड QR Code',
    trackOrderStatus: 'ऑर्डर स्थिति ट्रैक करें',
    all: 'सभी',
    noOrderThisStatus: 'इस स्थिति में कोई ऑर्डर नहीं',
    orderCompleteThanks: 'हमारी सेवा का उपयोग करने के लिए धन्यवाद!',
    OnPreparingYourOrder: 'आपका ऑर्डर तैयार हो रहा है...',
    goToTracking: 'ट्रैकिंग पेज पर जाएँ',
    "dine-in": 'डाइन-इन',
    typeOfOrder: 'ऑर्डर प्रकार',
    queue: 'कतार',
    cooking: 'पक रहा है',
    orderedAt: 'ऑर्डर किया',
    orderTimeStatus: 'ऑर्डर समय',
    acceptTimeStatus: 'स्वीकार समय',
    estTimeStatus: 'अनुमानित समय',
    newOrderDelivery: 'नया ऑर्डर',
    acceptOrderDelivery: 'ऑर्डर स्वीकार',
    readyToServeDelivery: 'परोसने के लिए तैयार',
    orderCompleted: 'ऑर्डर समाप्त',
    orderCanceled: 'ऑर्डर रद्द',
    readyToShip: 'शिपिंग के लिए तैयार',
    scanForPayment: 'भुगतान के लिए स्कैन करें',
    orderType: 'ऑर्डर प्रकार',
    welcomeBack: "वापस आने पर स्वागत है 👋",
    welcomeBackDespt: "खाना ऑर्डर करना जारी रखने के लिए लॉगिन करें",
    orLoginWith: "या इससे लॉगिन करें",
    dontHaveAccount: 'खाता नहीं है?',
    register: 'रजिस्टर',
    fullName: "पूरा नाम",
    fullNameDespt: 'आपका पूरा नाम',
    emailDespt: 'आपका ईमेल',
    createPassword: 'पासवर्ड बनाएं',
    alreadyHaveAccount: 'पहले से खाता है',
    verifyEmail: 'ईमेल सत्यापित करें',
    enterOTPSentTo: 'को भेजा गया OTP दर्ज करें',
    enterSixOTP: '6-अंकों का OTP दर्ज करें',
    verifyOTP: 'OTP सत्यापित करें',
    weWillSentOTPEmail: 'हम आपके ईमेल पर OTP भेजेंगे',
    enterYourEmail: 'अपना ईमेल दर्ज करें',
    confirmNewPassword: 'नया पासवर्ड की पुष्टि करें',
    sendOTP: 'OTP भेजें',
    addPhoneNumber: 'फ़ोन नंबर जोड़ें',
    addPhoneForRegister: 'पंजीकरण के लिए फ़ोन नंबर जोड़ें',
    enterPhone: 'फ़ोन नंबर दर्ज करें',
    phoneUsed: 'फ़ोन नंबर पहले से उपयोग में है',
    emailUsed: 'ईमेल पहले से उपयोग में है',
    enterPassword: 'पासवर्ड दर्ज करें',
    registerEmail: 'पंजीकृत ईमेल',
    otpInvalid6: "कृपया मान्य 6-अंकों का OTP दर्ज करें।",
    emailVerified: "ईमेल सफलतापूर्वक सत्यापित!",
    emailOrPasswordInvalid: 'अमान्य ईमेल या पासवर्ड',
    pleaseEnterEmail: 'कृपया अपना ईमेल दर्ज करें',
    otpSentToEmail: "आपके ईमेल पर OTP भेजा गया",
    passwordNotMatch: "पासवर्ड मेल नहीं खाते",
    resetPasswordCompleted: 'पासवर्ड सफलतापूर्वक रीसेट हो गया!',
    failResetPassword: 'पासवर्ड रीसेट करने में विफल',
    completePhoneFail: 'फ़ोन पंजीकरण विफल',
    plaseEnterValidEmail: 'कृपया मान्य ईमेल पता दर्ज करें',
    invalidPhoneNumber: 'फ़ोन 06, 08, या 09 से शुरू होना चाहिए और 10 अंक होने चाहिए',
    example: 'उदाहरण',
    passwordSet: "6 से अधिक अक्षर और एक संख्या होनी चाहिए",
    SelectTableToAdd: 'टेबल',
    availableTable: 'उपलब्ध',
    unAvailableTable: 'अनुपलब्ध',
    SelectTableToAddDesp: 'डाइन-इन के लिए टेबल चुनें<br>नोट: यदि आप टेबल बदलना चाहते हैं, तो कृपया स्टाफ से संपर्क करें',
    updatedStaus: 'स्थिति अपडेट हो गई',
    otpExpired: 'OTP समाप्त',
    and: "और",
    emailOTP: "ईमेल OTP",
    emailOTPDesp: "ईमेल पर प्राप्त OTP दर्ज करें",
    phoneOTP: "फ़ोन OTP",
    phoneOTPDesp: "SMS पर प्राप्त OTP दर्ज करें",
    checkSpamBox: '* यदि आपको ईमेल नहीं मिला है, तो कृपया अपना स्पैम या जंक फ़ोल्डर जाँचें। कभी-कभी आने में कुछ मिनट लग सकते हैं।',
    DineInPaymentPending: 'भुगतान लंबित',
    visitProceedPayment: 'भुगतान पर जाएँ',
    proceedPayment: "भुगतान जारी रखें",
    proceedPaymentDesp: "इस बिल का भुगतान प्रक्रिया में है।<br>यदि आप और आइटम ऑर्डर करना चाहते हैं,<br>कृपया पहले चल रहे भुगतान को रद्द करें",
    queueIndex: 'कतार',
    otpSentToPhone: 'SMS द्वारा OTP भेजा गया।',
    failToSendOTP: 'OTP भेजने में विफल',
    somethingWentWrong: 'कुछ गलत हो गया',
    tableHasNoOrder: 'टेबल पर कोई ऑर्डर नहीं',
    kbankProceedPaymentDesp: 'इस बिल का भुगतान प्रक्रिया में है।<br>यदि आप और आइटम जोड़ना या भुगतान विधि बदलना चाहते हैं,<br>कृपया पहले चल रहे भुगतान को रद्द करें'
,
  openHours: 'खुला',
}

export default messages
